import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AreaGateLogAdministrationComponent } from './area-gate-log-administration/area-gate-log-administration.component';
import { CommonFormattingModule, CommonLayoutModule, CommonTranslationModule, CommonUIButtonsModule, CommonUIModule, CommonUIFieldsModule } from '@sdbn/common';
import { AppClientResourcesModule } from '@sdbn/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTableModule as MatTableModule } from '@angular/material/table';
import { MatSort, MatSortModule } from '@angular/material/sort';


@NgModule({
  declarations: [
    AreaGateLogAdministrationComponent
  ],
  imports: [
    CommonModule,
    CommonLayoutModule,
    CommonUIFieldsModule,
    CommonTranslationModule,
    CommonUIButtonsModule,

    ReactiveFormsModule,
    AppClientResourcesModule,
    CommonFormattingModule,
    CommonUIModule,
    MatTableModule,
    MatSortModule
],
  exports: [
    AreaGateLogAdministrationComponent
  ]
})
export class AreaGateLogAdministrationModule { }
